import { render, staticRenderFns } from "./leave-requests.vue?vue&type=template&id=a980c9f2&scoped=true&"
import script from "./leave-requests.vue?vue&type=script&lang=js&"
export * from "./leave-requests.vue?vue&type=script&lang=js&"
import style0 from "./leave-requests.vue?vue&type=style&index=0&id=a980c9f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a980c9f2",
  null
  
)

export default component.exports